import React from "react";
import PropTypes from "prop-types";

// Color-coded status badge for the StoryIdea publication lifecycle
// (#3121). Deliberately just the badge — the status-specific date
// (publish_at for scheduled, published_at for published) and the
// scheduled-row relative countdown live in their own per-tab column
// on the index page now. Decoupling those means the status cell
// stays a clean glanceable indicator.
function StoryIdeaStatusBadge({ status }) {
  if (status === "published") {
    return (
      <span className="badge bg-success">
        <i className="fa-solid fa-check me-1" aria-hidden="true" />
        Published
      </span>
    );
  }
  if (status === "scheduled") {
    return <span className="badge bg-primary">Scheduled</span>;
  }
  // draft (default for any unrecognized status, deliberately fail-soft)
  return <span className="badge bg-secondary">Draft</span>;
}

StoryIdeaStatusBadge.propTypes = {
  status: PropTypes.oneOf(["draft", "scheduled", "published"]).isRequired,
};

export default StoryIdeaStatusBadge;
